export const en = {
  message: {
    dashboard: {
      messages: 'Messages',
      messagesNew: '{count} new',
      messagesProjects: '{count} projects',
      edit: 'Edit',
      done: 'Done',
      reset: 'Reset',
      theme: 'Theme',
      darkMode: 'Dark mode',
      featured: 'Featured',
      allModules: 'All modules',
      dragToFeature: 'Drag modules here to feature them',
      editHint: 'Drag to reorder · changes save automatically',
      editHintFeatured: 'Drag a module up to feature it · drag a hero down to remove',
      editHintBento: 'Drag to reorder · tap ⤢ to resize · changes save automatically',
      layoutTiles: 'Tiles',
      layoutSections: 'Sections',
      layoutBento: 'Bento',
      sectionWork: 'Work',
      sectionResources: 'Resources',
      sectionInfoMore: 'Info & More',
      modules: 'Modules',
      customizeModules: 'Customize modules'
    },
    layout: {
      login: 'Log in',
      ortext: 'OR',
      logout: 'Logout',
      rfidsignin: 'Sign In using RFID',
      SignInpassword: 'Sign in with Password',
      ScanRFID: 'Scan your RFID Tag',
      dashboard: 'Dashboard',
      timer: 'Timer',
      projects: 'Projects',
      stemp: 'Stemp',
      calendar: 'Calendar',
      deviation: 'Deviation',
      home: 'Home',
      deliver: 'Deliver',
      more: 'More',
      files: 'Files',
      equipments: 'Equipments',
      checklists: 'Checklists',
      drawing: 'Drawing',
      pressureTestReport: 'Pressure Test Report',
      weldlog: 'Weld Log',
      event: 'Event',
      ndt: 'NDT',
      surfaceReport: 'Surface Report',
      technicalReport: 'Technical Report',
      matrialList: 'Matrial List',
      pwht: 'PWHT',
      pwps: 'PWPS',
      wps: 'WPS',
      warehouse: 'Warehouse',
      tasks: 'Tasks',
      orders: 'Orders',
      orderno: 'Order No',
      facilities: 'Facility',
      chemicallist: 'Chemical List',
      nbselftL: '',
      asbuilt: 'AS-Built',
      autoLogout: 'Auto Logout'
    },
    login: {
      language: 'Language',
      back: 'Back',
      userName: 'Username',
      password: 'Password',
      authFailed: 'Authentication failed !',
      networkError: 'Cannot reach the server. Check your connection and the host name.',
      invalidCredentials: 'Wrong user name or password !',
      serverError: 'The server could not complete the sign in. Please contact support.',
      host: 'Host',
      forgotPassword: 'Forgot Password ?',
      forgotPasswordHint: 'Enter your e-mail address below to reset your password.',
      backToLogin: 'Back to Login',
      emailAddress: 'Email Address',
      resetMyPassword: 'Reset My Password'
    },
    common: {
      pwaNotEnabled: 'PWA is not enabled, please contact administrator',
      delete_row: 'Delete row',
      of: 'of',
      ready_for_production: 'Ready for production',
      production: 'Production',
      on_hold: 'On hold',
      finished: 'Finished',
      install: 'Install this application on your home screen for quick and easy access when you’re on the go.',
      justTab: 'Just tap',
      addToHome: 'then “Add to Home Screen”',
      english: 'English',
      norwegian: 'Norwegian',
      lithuanian: 'Lithuanian',
      polish: 'Polish',
      swedish: 'Swedish',
      save: 'Save',
      saveAndClose: 'Save & Close',
      send: 'Send',
      edit: 'Edit',
      cancel: 'Cancel',
      update: 'Update',
      delete: 'Delete',
      updateAndClose: 'Update & Close',
      close: 'Close',
      new: 'New',
      isActive: 'Is active',
      addNew: 'Add new',
      savedSuccess: 'Saved successfully!',
      addedSucess: 'Added successfully !',
      updatedSuccess: 'Updated successfully !',
      deleteSuccess: 'Deleted successfully !',
      errorOccured: 'An error occurred !',
      backToList: 'Back To List',
      search: 'Search',
      yes: 'Yes',
      no: 'No',
      isDefault: 'Is Default',
      loadingMsg: 'Loading, Please wait',
      deleteConfirm: 'Delete Confirm',
      areYouSure: 'Are you sure you want to delete ?',
      validationIssue: 'Please check the required fields!',
      total: 'Total',
      noResults: 'No results found !',
      statusUpdateFailed: 'Status was not saved. Please try again.',
      increaseHeight: 'Increase height',
      decreaseHeight: 'Decrease height',
      others: 'Others',
      typeHere: 'Type here...',
      position: 'Position',
      color: 'Color',
      maxCharacters: 'Max {charCount} characters',
      changedPassword: 'Password Changed Successfully',
      import: 'Import',
      note: 'Note',
      invalidEmail: 'Invalid Email',
      no_records: 'No Records Found!',
      no_data: 'No data available',
      ok: 'Ok',
      date: 'Date',
      comments: 'Comments',
      draftMsg: 'Saved as Draft',
      createProjectRole: 'Create Project Role',
      updateProjectRole: 'Update Project Role',
      module: 'Module',
      selectTemplate: 'Select Template',
      documentTemplate: 'Document Template',
      download: 'Download',
      uploadedSuccess: 'Uploaded successfully !',
      weekTotalHours: 'Week hrs',
      addWorktype: 'Add Worktype',
      updateWorktype: 'Update Worktype',
      worktype: 'Worktype',
      newUpdate: 'New Update Available!',
      discardChangesAndUpdate: 'You have unsaved changes. Discard them and update?',
      updateAfterSave: 'A newer version is available. Save your work, then the app will update.',
      refresh: 'Refresh',
      retry: 'Retry',
      somethingWentWrong: 'Something went wrong',
      online: 'Connected',
      offline: 'Offline',
      moduleName: 'Module Name',
      updatedOn: 'Updated On',
      columns: 'Columns',
      confirmCancel: 'Confirm Cancel',
      areYouSureCancel: 'Are you sure you want to cancel ?',
      not_approved_notification: 'Hi! {count} time registration(s) in week {weeknumber} is not approved',
      hourExceedNotification: 'Entered hour is exceeding the 24 hours',
      options: 'Options',
      label: 'Label',
      value: 'Value',
      confirmStatusChange: 'Confirm Status change',
      areYouSureToChangeStatus: 'Are you sure you want to change status to {statusText} ?',
      complete: 'complete',
      incomplete: 'incomplete',
      name: 'Name',
      number: 'Number',
      noPermission: "Sorry! You don't have permission to {permissionType} {module}",
      charsLimit35: 'Please enter no more than {length} characters',
      confirmAddHour: 'Shift has been completed!',
      sureToAddExceedingHour: 'Entered hour is exceeding the Working hours, Are you sure to add ?',
      warning: 'Warning',
      required: 'Required',
      timerFeatureDisabled: 'Timer feature disabled',
      locationNotSet: 'Location not set',
      type: 'Type',
      changeVideoSource: 'Change video source',
      permissionDenied: 'Camera permission is denied!, please enable it in the browser settings!',
      time: 'Time',
      orderno: 'Order No',
      ndt_percentage_error: 'NDT percentage must have 0 to 100',
      lengthError: 'The length must be less than 10',
      update_properties: 'Update Properties',
      add_properties: 'Add Properties',
      preparing_fields: 'Preparing fields...',
      from_attributs: 'FORM ATTRIBUTES',
      enter_title: 'Enter Title Of Each Columns:',
      loading_grid: 'Loading Grids...',
      from_properties: 'FORM PROPERTIES',
      dragging: 'Dragging...',
      catch_up: 'All caught up!!!',
      add_header: 'Add Header',
      add_footer: 'Add Footer',
      drop_fields: 'Drop the fields here',
      for_header: 'FOR HEADER',
      for_footer: 'FOR FOOTER',
      add_html: 'ADD HTML CONTENT',
      relate: 'Relate',
      unrelate: 'Unrelate',
      values: 'Values',
      scan: 'Scan',
      filename: 'Filename',
      fitToScreen: 'Fit to screen',
      actualSize: 'Actual size',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      reset: 'Reset',
      doYouWantContinue: 'Still do you want to continue ?',
      stempHint: 'If you choose Shift, you can start the stamp',
      hoursExeed: 'exeeding 24 hours',
      on: 'On',
      reachedHours: 'Reached 24 hours',
      invaliHours: 'Invalid Hours',
      notValidNumber: 'Not Valid Number',
      invalidName: 'Invalid name',
      filterSaveResult: 'Search enables you to see the filter you have applied and the filtered result can be seen in the report only if you save the checklist',
      seemsInvalid: 'Hours seems to be not valid!',
      shiftContinue: 'Your stemp hour continues...',
      no_fields_found: 'No checklist fields found',
      sharePoint: 'Sharepoint might have incorrect credentials or configurations are missing !.',
      dragAndDropTips: 'Saving is mandatory on every drag and drop to avoid misplacing of rows',
      afterCopyFilter: 'Filter acion will be performed until you save the checklist',
      archived: 'Archived',
      datagrid_filter_help_text_1: 'Results will be filtered as same as last time filter options.',
      datagrid_filter_help_text_2: 'On adding a new row, filters will be removed and all rows will be added.',
      datagrid_filter_help_text_3: 'Filters are case insensitive, so we can use both Upper case and Lower case.',
      datagrid_filter_help_text_4: "We can't filter same column twice.",
      datagrid_filter_help_text_5: 'Drag and drop will be modified by filter result, if user save the checklist.',
      datagrid_filter_help_text_6: 'The text area filtered by the word between any part of the sentence.',
      datagrid_filter_help_text_7: "It is mandatory to fill both field and it's value to perform filter action.",
      sharepointCharacters: "This field should not contain any of these characters '*:<>?/\\|.'",
      company: 'Company',
      filenotfound: 'File not found',
      folder: 'Folder',
      folders: 'Folders',
      files: 'Files',
      emptyFolder: 'This folder is empty',
      emptyFolderHint: 'Published documents will show up here',
      gridView: 'Grid view',
      listView: 'List view',
      back: 'Back',
      searchResults: 'Search results',
      previousDocument: 'Previous document',
      nextDocument: 'Next document',
      imagedraw: 'Image Draw'
    },
    timer: {
      stop: 'Stop',
      ga_til_time: 'Go to Hourlist',
      minutes: 'minutes',
      start: 'Start',
      place: 'Place',
      hours: 'Hours',
      activity: 'Activity',
      inactive_suffix: '(inactive)',
      not_linked_warning: 'This entry will not be transferred to {integration} — something is not linked',
      pause: 'Pause',
      from: 'From',
      till: 'Till',
      shift: 'Shift',
      startTime: 'Start time',
      endTime: 'End time',
      editHours: 'Edit Hour',
      approved: 'Approved',
      notApproved: 'Not Approved',
      delivered: 'Delivered',
      notDelivered: 'Not Delivered',
      year: 'Year',
      week: 'Week',
      nonBillable: 'Non Billable',
      hourlogging: 'Hourlogging',
      noHours: 'No hours found for deliver !',
      deliveredMsg: 'Delivered Successfully',
      addHours: 'Add Hour',
      deliverHours: 'Deliver hours',
      hoursExceeding: 'Timer Exceeded 8 hours',
      cancelTimer: 'Cancel Timer',
      uploadSuccess: 'Upload Success',
      picture: 'Take a Picture',
      imageNeeded: 'Please upload a picture before you stop the timer!',
      nonbillableworktype: 'Vacation / Absence type',
      additionalWorktype: 'Additional work type',
      additional_hours: 'Additional hours',
      select: 'Select',
      check_field: 'Check this field',
      check_fields: 'Please check: {fields}',
      inactive_work_type: 'The selected work type is inactive. Choose another one.',
      inactive_activity: 'The selected activity is inactive. Choose another one.',
      additional_hours_positive: 'Additional hours must be greater than 0',
      additional_hours_exceed: 'Additional hours cannot be more than the hours worked ({hours})',
      switchProject: 'Switch Project',
      reasonForSwitchingProject: 'Reason for switching project',
      projectSwitchedSuccessfully: 'Project switched successfully',
      failedToSwitchProject: 'Failed to switch project',
      selectDifferentProject: 'Please select a different project'
    },
    projects: {
      chatOpen: 'Open',
      chatEditMembers: 'Edit members',
      chatEditMembersHint: 'Tick who should be in this conversation. Anyone added can read the whole history.',
      chatCreate: 'Create',
      chatParticipants: 'Participants',
      chatNewPrivate: '+ New',
      chatSend: 'Send',
      chatPrivate: 'Private',
      chatSeenBy: 'Seen by {count}',
      chatSent: 'Sent',
      chatEveryone: '{count} participants · everyone with project access',
      chatPrivateOnly: 'Only {names} can see this conversation',
      chatNewPrivateTitle: 'New private conversation',
      chatNewPrivateHint: 'Pick who can see this conversation.',
      chat: 'Chat',
      chatConversations: 'Conversations',
      chatEmpty: 'No messages yet.',
      chatPlaceholder: 'Write a message...',
      chatOpenWeldMapping: 'Open weld mapping',
      chatYou: 'you',
      chatEdited: 'edited',
      chatConfirmDelete: 'Delete this message?',
      chatToday: 'Today',
      chatYesterday: 'Yesterday',
      startDate: 'Start date',
      endDate: 'End date',
      projectNo: 'Project no.',
      projectname: 'Projectname',
      aoRanked: 'AO Ranked',
      workOrderName: 'Work order name',
      all: 'All',
      allActive: 'All Active',
      myAll: 'My All',
      myActive: 'My Active',
      project: 'Project',
      customer: 'Customer',
      status: 'Status',
      noActiveProjects: 'No Active Projects!',
      selectProject: 'Select Project',
      projectMaterialDisabled: 'Materials disabled for this project',
      drawingGroup: 'Drawing Group',
      allDrawingGroups: 'All groups',
      sectionIdentification: 'Identification',
      sectionStatusAttachments: 'Status and attachments',
      sectionReportDetails: 'Report details',
      sectionWelding: 'Welding',
      sectionMaterials: 'Materials',
      sectionInspection: 'Inspection (NDT)'
    },
    calendar: {
      today: 'Today',
      month: 'Month',
      day: 'Day',
      weekNotExists: "Week doesn't exist",
      yearValid: 'Must be four digits',
      valid: 'Must be valid',
      yearTooLessValidation: 'Year must be greater than 1920',
      weekLock: 'Selected dates are in the locked week',
      dayLocked: 'Selected date is in the locked week',
      otherHourEntries: 'Other hour entries'
    },
    shifts: {
      shift: 'My shifts',
      documents: 'Documents:',
      not_found: 'No description and url found.',
      notValidPausedTime: 'Pause time is greater than shift time',
      continue: 'Continue',
      clear: 'Clear'
    },
    deviation: {
      deviations: 'Deviation',
      register_deviation: 'Register Deviation',
      view_deviation: 'View Deviation',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      closed: 'Closed',
      registered: 'Registered',
      process: 'Process',
      actions: 'Actions',
      title: 'Title',
      reported_by: 'Reported By',
      location: 'Location',
      reason: 'Reason',
      document: 'Document',
      category: 'Category',
      estimate_cost: 'Estimate Cost',
      severity: 'Severity',
      deviation_status: 'Deviation Status',
      deadline: 'Deadline',
      description: 'Description',
      responsible: 'Responsible',
      copyto: 'Copy To',
      upload_files: 'Upload',
      required_message: 'This field is required',
      consequences: 'Consequence',
      changeRequest: 'Change Request',
      hse: 'HSE',
      deviation_number: 'Deviation Number',
      underlying_reason: 'Underlying Reason',
      corrective_actions: 'Corrective Actions',
      effect_of_measures: 'Effect Of Measures',
      sectionRegistration: 'Registration',
      sectionClassification: 'Classification',
      sectionFollowUp: 'Follow-up',
      sectionWhatHappened: 'What happened',
      sectionCorrectiveAction: 'Corrective action',
      sectionAttachments: 'Attachments',
      readonlyNotice: 'You do not have permission to edit this deviation. Fields are shown for reference only.'
    },
    checklist: {
      title: 'Checklist',
      updateChecklist: 'Update checklist',
      pickCheckList: 'Select a checklist',
      addCheckList: 'Add checklist',
      hmsKs: 'HMS/KS',
      templateName: 'Template name',
      checklist_recipients: 'Email recipient',
      checklist_recipient_hint: 'Enter email using comma(,) separated.',
      projectnr: 'PO Ranked',
      projectname: 'Projectname',
      aonr: 'AO Ranked',
      workordername: 'Work order name',
      customer: 'Customer',
      customercontact: 'Customer contact',
      projectleader: 'Project Leader',
      importCSV: 'Import CSV',
      CSVFileInfo: 'Here you can import data from an csv file into a checklist.',
      removeRow: 'Remove 1. row if it has headers.',
      sameOrederColumn: 'Make sure the columns are in the same order as u have defined it in the checklist.',
      semicolonDelimiter: 'Please use semicolon as csv delimiter.',
      withoutImport: 'Without Import',
      addCSVFile: 'Add CSV File',
      report_header: 'Report header',
      copy_confirm: 'Do you want to copy the checklist?',
      filter: 'Filter',
      apply: 'Apply',
      image: 'Image',
      no_comment: 'No comment',
      action: 'Action',
      cameraCapture: 'Camera Capture',
      openCamera: 'Open Camera',
      takePhoto: 'Take Photo',
      uploadDocument: 'Open camera and upload photo',
      retake: 'Retake'
    },
    equipments: {
      equipment: 'Equipment',
      addEquipment: 'Add Equipment',
      updateEquipment: 'Update Equipment',
      viewEquipment: 'View Equipment',
      active: 'Active',
      quarantine: 'Quarantine',
      discarded: 'Discarded',
      warrantydate: 'Warranty Date',
      dateofPurchase: 'Date of Purchase',
      vendor: 'Vendor',
      modelNumber: 'Model Number',
      product: 'Product',
      serialNumber: 'Serial Number',
      capacity: 'Capacity',
      groups: 'Groups',
      plannedCalibration: 'Planned Calibration',
      scrapDate: 'Scrap Date',
      equipmentNumber: 'Equipment Number',
      placement: 'Placement',
      notifyByEmail: 'Notify by Email',
      mustAllocateToProjectOrLocation: 'Must allocate the equipment to either Project or Location.',
      confirm: 'Are you sure?'
    },
    customModule: {
      modules: 'Modules',
      customModule: 'Custom module',
      customModules: 'Custom modules',
      uploadDocument: 'Upload Document',
      isCompleted: 'Is Completed',
      add: 'Add',
      urlNotFound: 'Download url not found',
      completed: 'Completed',
      notCompleted: 'Not completed',
      fileSizeLimitMsg: 'File Size limit exceeded for one or more files (Max.Limit {maxSize}MB).',
      invalidFileType: 'File type not allowed'
    },
    moduleReports: {
      title: 'Module reports',
      chartyAxis: 'Number Of Records (per module)'
    },
    projectFeature: {
      drawingNumber: 'Drawing nr.',
      poRanked: 'PO Ranked',
      operator: 'Operator',
      reportNumber: 'Report nr.',
      uploadNdtDocument: 'Upload NDT Document',
      aoRanked: 'AO Ranked',
      NDTSpecifications: 'NDT Specifications',
      NDTScope: 'NDT Scope',
      filterMaterials: 'Filter Materials',
      chargedLotNumber: 'Charde/Lot nr.',
      selectFiles: 'Select files',
      createdOn: 'Created On',
      weldingID: 'Welding ID',
      weldNumber: 'Weld nr.',
      wpsNumber: 'WPS nr.',
      wpsAsComma: 'Enter WPS no. As comma separated.',
      weldEnd: 'Weld End',
      vtSignDate: 'VT Sign./Date',
      rtSignDate: 'RT Sign./Date',
      utSignDate: 'UT Sign./Date',
      mtPtSignDate: 'MT/PT Sign./Date',
      createdDate: 'Created Date',
      tegNr: 'Teg nr.',
      tegNrWpsNr: 'Teg nr. / Wps nr.',
      posNr: 'Pos nr.',
      batchNr: 'Batch nr.',
      heatNr: 'Heat nr.',
      onStock: 'On Stock',
      weldingConsumable: 'Welding consumable',
      registerBatchAgainstWps: 'Register batch no. against a WPS, for the weld log',
      out: 'Out',
      sectionIdentification: 'Identification',
      sectionStock: 'Stock',
      sectionStatus: 'Status and attachments',
      descriptionHint: 'Description',
      recordNumber: 'Record Number',
      chartSpeed: 'Chart Speed',
      chartNumber: 'Chart Number',
      unrestrictedTo: 'Unrestricted To',
      restrictedRateOfRise: 'Restricted Rate of Rise',
      holdTemperatureRequired: 'Hold Temperature Required',
      holdTemperatureActual: 'Hold Temperature Actual',
      holdTimeActual: 'Hold Time Actual',
      holdTimeRequired: 'Hold Time Required',
      restrictedRateDown: 'Restricted Rate Down',
      unrestrictedRateOfFall: 'Unrestricted Rate of Fall',
      weldDate: 'Weld date',
      performedBy: 'Performed By',
      approvedBy: 'Approved By',
      approvedDate: 'Approved Date',
      weldLogDate: 'Weld date',
      productNumber: 'Product number',
      weldLength: 'Welding length(mm)',
      designation_1: 'Part 1 Designation',
      designation_2: 'Part 2 Designation',
      thickness_1: 'Thickness 1(mm)',
      thickness_2: 'Thickness 2(mm)',
      weld_diameter: 'Welding diameter(mm)',
      notAccepted: 'Not accepted',
      ndtStatus: 'Ndt status',
      isDiameter: 'Is diameter',
      ndt: '%NDT',
      weldingCompound: 'Welding Compound',
      batch_lot: 'Batc/lot',
      choose: 'Choose',
      pipe_description: 'Pipe description'
    },
    whsDashboard: {
      scanText: 'Scan order number or barcode',
      customerOrder: 'Customer orders',
      receiveSupplierOrder: 'Receive supplier orders',
      adjustmentOrders: 'Adjustment orders',
      transferOrders: 'Transfer orders',
      cycleCount: 'Cycle count',
      product: 'Product',
      supplierOrder: 'Supplier order',
      returnOrder: 'Return order'
    },
    ccsheet: {
      warehouse: 'Warehouse',
      created: 'Created',
      counted: 'Counted',
      count: 'Count',
      reCount: 'Recount',
      closeComplete: 'Close & Complete',
      unit: 'Unit',
      stock: 'Stock',
      scanLocation: 'Scan or enter location',
      nextLoc: 'Next Loc',
      info: 'Message!',
      continueCount: 'Continue counting',
      clearAndRecount: 'Clear & recount',
      completeRecount: 'Complete recount',
      ccsheetComplete: 'CCSheet will be completed. Continue?',
      noSheetFound: 'No CCSheet Found!',
      noProductOnLocation: 'No product is found on this location!',
      stockTake: 'Stock take for the chosen location has already been performed. Do you want to continue counting in this location or clear data and perform new stock take?',
      ccsheetAddProduct: 'Product is not added to this ccsheet would like to add ?'
    },
    product: {
      supplierartno: 'Supplier article number',
      supplier: 'Supplier Name',
      barcode: 'Barcode',
      noProductFound: 'No Product Found!',
      minQty: 'Min Qty',
      orderQty: 'Order Qty',
      qty: 'Qty',
      batch: 'Batch',
      scanLoc: 'Select Loc.',
      noLocFound: 'No Location Found!'
    },
    order: {
      products: 'Products',
      avail: 'Avail',
      ordered: 'Ord.',
      received: 'Rec.',
      pickedQty: 'Pic.',
      pickOrder: 'Pick order',
      pickProducts: 'Pick products',
      delivery: 'Del',
      rest: 'Rest',
      complete: 'Complete',
      pick: 'Pick',
      scanProduct: 'Scan barcode of a product',
      scanBatch: 'Scan batchnumber',
      picked: 'Picked',
      toPick: 'To pick',
      location: 'Loc',
      pickLocation: 'Select location',
      qtyExceeds: 'Qty Exceeds',
      noOrderFound: 'No order found!',
      notValidBatch: 'Batchnumber is not valid!',
      receiveOrder: 'Receive order',
      receive: 'Receive',
      batchExists: 'Batch number already exists!',
      receiveWarning: 'Would you like to add {qty} pcs of {product} to stock?',
      completedSuccess: 'Completed successfully!',
      addFreight: 'Do you want to add freight?',
      cost: 'Cost',
      price: 'Price',
      orderedQtyHigh: 'Qty received is higher than ordered, would you like to proceed?',
      collect: 'Collect',
      receiving: 'Receiving',
      availableToPick: 'Avail qty(s) to receive',
      adjust: 'Adjust',
      orderComplete: 'Order will be completed. Continue?',
      orderDate: 'Order date'
    },
    tasks: {
      forYour: 'For your',
      information: 'Information',
      acknowledge: 'Acknowledge',
      review: 'Review',
      approval: 'Approval',
      subject: 'Subject',
      dueDate: 'Due date',
      approve: 'Approve',
      disapprove: 'Disapprove',
      keep: 'Keep',
      remove: 'Remove'
    },
    mixed: {
      scanSerialNumber: 'Scan serial number',
      noEquipmentFound: 'No equipment found',
      sharedUrl: 'Shared url',
      checklistfiles: 'Checklist Files',
      attachments: 'Attachments',
      signature: 'Signature',
      nochecklists: 'No checklists',
      checklistName: 'Checklist Name',
      noOfDocuments: 'No.Of.Documents',
      documentTitle: 'Document title',
      qrCode: 'QR Code',
      qrQty: 'QR Quantity',
      scanQRCode: 'Scan QR Code',
      irscanner: 'Ir Scanner',
      attachmentsBelow: 'Find Attachments below',
      noChemicalFound: 'No Chemical list Found',
      barCodeNotDecoded: 'Failed to decode the barcode from the QR code.',
      scanBarcode: 'Scan Barcode'
    },
    chemicallist: {
      chemical: 'Chemical',
      provider: 'Provider',
      repository: 'Repository',
      last_revised: 'Last revised',
      viewChemical: 'Chemical',
      chemicalName: 'Chemical name'
    },
    news: {
      news: 'News',
      next: 'Next',
      previous: 'Previous'
    },
    // Production series (WIT-PROTO-PRODSERIES-PWA-001). Copy mirrors the
    // backend's resources/lang/en/production_series.php (key in comment).
    productionSeries: {
      idModeSpool: 'Spool/part no.', // id_mode_spool
      idModeSeq: 'Without spool/part no. — sequence number', // id_mode_seq
      seriesOf: 'Series', // series_of
      nWelds: '{n} welds', // n_welds
      hasProductionData: 'Has production data', // has_production_data
      unitsWelds: '{units} units · {welds} welds', // units_welds
      unitRetainedSuffix: ' · retained', // unit_retained_suffix
      markerDone: '{done}/{total} welded', // marker_done
      noUnit: 'no spool/part no.' // Decision B tag (task copy)
    },
    weldMapping: {
      // 5183 / S18: one batch/heat per welding method.
      methodBatchesLabel: 'Batch / heat per method',
      methodBatchesHint: 'This weld uses more than one welding process. Record the batch used for each.',
      // 5183 / S4: production-series units under a drawing.
      unitsHeading: 'Spool / part numbers',
      unitScoped: 'Showing spool {unit}',
      unitShowAll: 'Show all',
      unsavedHint: 'Unsaved changes — use the button below to discard them',
      batchMissing: 'Batch/charge not registered — enter it before completing',
      supersededBy: 'Replaced by {weld} — register the repair on that weld',
      previewWps: 'Preview WPS',
      comment: 'Comment',
      copyMaterial: 'Copy material',
      vtRejectedOn: 'VT rejected on',
      by: 'by',
      reason: 'Reason:',
      repairOf: 'Repair of',
      wireBatchTitle: 'Welding wire · batch/charge',
      batchPf: 'Batch welding filler material',
      batchPfHint: 'Scan or type batch…',
      assemblyPf: 'Assembly (PF) certificate (optional)',
      weldCertificate: 'Weld certificate',
      certGroupQualified: 'Qualified',
      certGroupCannotVerify: 'Cannot verify',
      certGroupNotQualified: 'Not qualified',
      certNoneQualified: 'No qualified certificate for this weld',
      certLockedTitle: 'Weld locked — no certificate',
      certLockedMsg: 'You don\'t hold a certificate that qualifies for this weld. Ask the welding coordinator.',
      certAdvisoryTitle: 'Certificate not confirmed',
      certAdvisoryMsg: 'None of your certificates could be confirmed for this weld. You may still sign — the choice is recorded on the weld.',
      // WIT-FIX-CERT-5348-001 F5a: the advisory is a not_qualified finding, not cannot_verify.
      certNotQualifiedTitle: 'Not covered by a certificate',
      // WIT-FIX-CERT-5355-001 F5a / D-5355-3 (Erik 15.10): what none of the welder's certificates covers, then how to go on.
      certNotQualifiedMsg: 'None of your certificates covers this weld{codes}. You can sign with a reason — the welding coordinator will see it.',
      certNotQualifiedLead: 'None of your certificates covers this weld.',
      certSignWithReasonHint: 'You can sign with a reason — the welding coordinator will see it.',
      certReasonWelder: 'Say briefly why you are signing without a qualifying certificate (e.g. «certificate not registered yet»). The welding coordinator sees the reason in the weld log.',
      certNoValidMsg: 'You hold no valid welding certificate for this weld. You may sign — the weld is flagged for the welding coordinator.',
      certMissingProcess: ' (process {codes} missing)',
      // F2: the office override on the sheet (server weld_mapping.cert_ui.override_tip_* twins).
      certOverrideTipReason: 'Reason: {reason}',
      certOverrideTipBy: 'By: {by}',
      certOverrideTipAt: 'When: {at}',
      certAutoHint: 'Chosen automatically from your valid certificates when you press «Weld complete».',
      certConfirmTitle: 'Confirm certificate',
      certConfirmBtn: 'Confirm',
      // WIT-FIX-RETEST-1008-001 P-C: under the confirm intro, only for «Kan ikke verifiseres».
      certConfirmManualNote: 'Your choice is marked «Confirmed manually» and shown to the welding coordinator.',
      // P-C: the chip for a welder's own confirmation (cert_verdict cannot_verify_confirmed).
      certVerdictConfirmed: 'Confirmed manually',
      // P-D: the stop under «Blokker» when nothing the welder holds can apply.
      certBlockedTitle: 'The weld cannot be registered',
      certOverrideTitle: 'Not covered by a certificate',
      certOverrideBlock: 'This project requires a qualifying certificate. Give a reason to sign anyway — the welding coordinator sees it in the weld log.',
      certOverrideWarn: 'The weld is signed and flagged for the welding coordinator. You can add a reason.',
      certReasonLabel: 'Reason',
      certReasonRequired: 'A reason is required.',
      // WIT-FIX-WELDMAP-002 (certificates 3.4 / 3.5)
      certRankedTitle: 'Your certificates for this weld:',
      welderIdMissing: 'Welder ID missing',
      welderIdMissingHint: 'Signed without a welder ID — add the welder ID to your user profile.',
      certSignBtn: 'Sign',
      certLockedOverride: 'You can sign with a reason — the welding coordinator sees it.',
      certVerdictQualified: 'Qualified',
      certVerdictUnverified: 'Not verified',
      certVerdictNotQualified: 'Not qualified',
      certVerdictNotChecked: 'Not checked',
      // WIT-IMPL-CERT-001 P2/P3
      certVerdictOverride: 'Overridden',
      certFlaggedToast: 'Signed and flagged for the welding coordinator.',
      undoSign: 'Undo sign-off',
      undoSignDone: 'The sign-off of {weld} was undone.',
      // WIT-IMPL-CERT-001 P4 (office picker)
      certShowAllWelders: 'Show all welders in the company',
      certNonParticipant: 'not on the project',
      certNonParticipantReason: 'This welder is not on the project. Give a reason — the choice is stored as an override.',
      noServerAnswer: 'No answer from the server. Check the connection and try again — nothing was saved.',
      certMatchChecking: 'Checking certificates…',
      // WIT-FIX-PWA-WELDERCERT-001 (Erik 09.10.2026): the welder's own picker.
      certAutoPick: 'Chosen automatically · {n} relevant',
      certOwnHeading: 'Your relevant certificates',
      certOwnHidden: 'Hidden: {n} of your certificates do not cover the process/weld type.',
      certNoCertificates: 'You have no welding certificate on record. Contact the welding coordinator.',
      certNoneRelevant: 'You hold no certificate that qualifies for weld {weld}. Contact the welding coordinator.',
      assemblyPfHint: 'Select certificate …',
      search: 'Search',
      nSelected: '{n} selected',
      assemblyPfNone: 'No certificates available',
      batchPfRequired: 'Enter the filler material batch to complete assembly',
      required: 'required',
      rejectWhy: 'Why is the joint rejected?',
      rejectNote: 'Note (optional)',
      vtLevelIso: 'VT level (ISO 5817)',
      vtLevelFromWeld: 'Set on the weld',
      vtLevelOverriding: 'Changing level',
      vtLevelNotSet: 'Not set',
      vtLevels: {
        B: 'Strict',
        C: 'Medium',
        D: 'Moderate'
      },
      faults: {
        undercut: 'Undercut',
        porosity: 'Porosity',
        spatter: 'Spatter',
        fusion: 'Lack of fusion',
        geometry: 'Geometry',
        other: 'Other'
      },
      uploading: 'Uploading…',
      photoSaved: 'Photo saved',
      fromWps: 'from WPS',
      change: 'Change',
      batchCharge: 'Batch / charge no.',
      batchChargeHint: 'Select batch …',
      batchAdd: 'Add',
      batchAddNew: '+ Add new batch …',
      batchGroupWps: 'For this WPS',
      batchTypeNew: 'Other… (type new batch)',
      batchPickFromList: 'Choose from list',
      takePhoto: 'Take photo',
      uploadPhoto: 'Upload photo',
      signedAs: 'Signed with your user',
      title: 'Weld Mapping',
      featureDisabled: 'You do not have access to Weld Mapping.',
      searchDrawing: 'Search drawing',
      continue: 'Continue',
      lastOpened: 'Last opened',
      allDrawings: 'All drawings',
      childDrawings: 'Child drawings',
      welds: 'welds',
      hasChildren: '{count} sub-drawings',
      noMatch: 'No matching drawings',
      noMatchHint: 'Try another drawing number.',
      mapComingNext: 'Weld map opens here in the next step.',
      drawingsShort: 'Drawings',
      prevDrawing: 'Previous drawing: {number}',
      nextDrawing: 'Next drawing: {number}',
      firstDrawing: 'First drawing',
      lastDrawing: 'Last drawing',
      ownJoints: 'Own joints',
      ownMap: 'Open weld map for {number}',
      ownSub: '{count} welds on the drawing itself',
      joints: 'Joints',
      toggleJoints: 'Show or hide the joints list',
      noJoints: 'No welds on this drawing',
      // Which STAGE a drawing has reached (D-5170-1).
      drawingStage: {
        pending: 'Not started',
        mapping: 'Being mapped',
        mapped: 'Mapped',
        welding: 'Being welded',
        ndt: 'Awaiting inspection',
        // «VT fullført» (WIT-IMPL-PWA-DRAWINGSTATUS-003): alt sveist og VT
        // signert, men en annen påkrevd NDT-metode gjenstår.
        vt_done: 'VT complete',
        done: 'Complete'
      },
      status: {
        MAPPED: 'Mapped',
        FITTED: 'Fitted',
        WELDED: 'Welded',
        COMPLETED: 'Completed',
        REPAIR: 'Repair'
      },
      wps: 'WPS',
      process: 'Method',
      filler: 'Filler',
      vtLevel: 'VT level',
      trace: 'Traceability',
      fittedBy: 'Fitted by',
      weldedBy: 'Welded by',
      vtBy: 'VT by',
      batch: 'batch',
      wire: 'wire',
      level: 'level',
      vtRejectedBy: 'VT rejected by',
      vtPending: 'Waiting for VT control',
      field: {
        title: 'Field-registered weld',
        legend: 'Field-registered (awaiting office)',
        addBtn: 'Add weld in field',
        placeHint: 'Tap the drawing where the new weld goes',
        cancel: 'Cancel',
        queued: '{n} registration(s) waiting for connection',
        syncNow: 'Sync now',
        wpsDeviation: 'WPS deviation',
        newTitle: 'New weld – field-registered',
        editTitle: 'Edit field-registered weld',
        newSub: 'Registered by the welder on site and flagged for review by the office.',
        loadingOptions: 'Loading registers…',
        after: 'After weld',
        weldNr: 'Weld no.',
        idHint: 'Letter + the preceding weld\'s number: the first between W-0005 and W-0006 becomes A-0005, then B-0005, C-0005 …',
        reason: 'Reason',
        pickReason: 'Choose reason…',
        pick: 'Choose…',
        joint: 'Joint',
        groove: 'Groove type',
        pickGroove: 'Choose groove type…',
        pickJointFirst: 'Choose joint first',
        pickWps: 'Choose WPS…',
        material: 'Base material',
        materialsFailed: 'The material register could not be loaded. Try again, or tell the office.',
        thickness: 'Thickness (mm)',
        weldLength: 'Length mm',
        spool: 'Spool/part no.',
        pickSpool: 'Select spool/part no.…',
        spoolHint: 'This drawing has several spool/part numbers — pick the one this weld is on.',
        validRange: 'valid {min}–{max} mm',
        warnNotBlocking: 'The weld can be saved, but the deviation is flagged to the office.',
        warnMaterial: 'Material {material} is not covered by {wps}.',
        warnThickness: 'Thickness {t} mm is outside the WPS validity range ({min}–{max} mm).',
        // WIT-IMPL-WPS-5324-003 (F4): weld_mapping.field_wps_no_process twin.
        warnNoProcess: 'WPS {wps} has no welding process – the certificate cannot be verified.',
        optional: 'optional',
        notePh: 'E.g. location, deviation, reference…',
        save: 'Save weld',
        registeredToast: '{weld} registered — sent to the office for review',
        queuedToast: '{weld} saved on the device — sent to the office when back online',
        updated: '{weld} updated',
        registered: 'Registered',
        reviewComment: 'Comment from the office',
        office: 'Office',
        approve: 'Approve',
        reject: 'Reject',
        remove: 'Remove from drawing',
        edit: 'Edit registration',
        rejectedNote: 'Rejected by the office — remove it or register the weld again.',
        localPending: 'Waiting for connection — not yet sent to the office.',
        delete: 'Delete registration',
        deleteConfirm: 'Delete {weld}? The registration is removed from the drawing and the weld log.',
        deleteHasData: 'The weld has production data ({status}) and cannot be deleted here.',
        decision: {
          rejected: 'Rejected by the office',
          approved: 'Approved by the office'
        },
        notifications: 'Notifications',
        noNotifications: 'No notifications',
        status: {
          pending: 'Field-registered',
          approved: 'Approved',
          rejected: 'Rejected'
        },
        sub: {
          pending: 'awaiting office approval',
          approved: 'field-registered · approved',
          rejected: 'rejected by the office',
          local: 'waiting for sync'
        },
        reasons: {
          missed_in_mapping: 'Missed in mapping',
          unforeseen_pipe_joint: 'Unforeseen pipe joint',
          site_change: 'Site change',
          other: 'Other'
        },
        joints: {
          BW: 'BW – Butt weld',
          FW: 'FW – Fillet weld',
          'BW-ROR': 'BW – Pipe joint'
        },
        grooves: {
          V: 'V-groove',
          X: 'X-groove',
          I: 'I-groove',
          U: 'U-groove',
          HV: 'HV-groove',
          J: 'J-groove',
          FILLET_A: 'Fillet (a-dimension)'
        },
        notif: {
          field_weld_registered: '{weld} registered in the field — review needed',
          field_weld_approved: '{weld} approved by the office',
          field_weld_rejected: '{weld} rejected by the office'
        }
      },
      // WIT-IMPL-M101-PWA-001: read-only NDT context per joint (server-derived)
      // and the hold-welding warning carrier. Never a block.
      ndtContext: {
        title: 'NDT context',
        classDefault: 'Class',
        classM101: 'Inspection category (NORSOK N-004)',
        classM601: 'NDT group (NORSOK M-601 table 2)',
        jointType: 'Joint type',
        weldType: 'Weld type',
        penDepth: 's (mm)',
        holdTime: 'Hold time before NDT',
        earliestNdt: 'Earliest NDT',
        pending: 'To be clarified',
        status: 'Status',
        hold: {
          pwht: 'none (NDT after PWHT)',
          default_48: '48 h',
          smys_le_355: '24 h (SMYS ≤ 355, documented)',
          smys_le_460_thin: '24 h (SMYS ≤ 460 and t < 40 mm, documented)',
          smys_missing: '48 h (yield strength missing)',
          thickness_missing: '48 h (thickness missing)',
          // WIT-FIX-M101-001: table G.1 fixed hold; no SMYS because the material is unlinked.
          g1_fixed_48: '48 h (10.1)',
          material_unlinked: '48 h – material not linked to a standard material',
          // WIT-IMPL-SVV-R761-002: NS-EN 1090-2 table 23 (SVV R761).
          table23: '{h} h (NS-EN 1090-2 table 23)',
          table23_cooling: 'only cooling (table 23)',
          table23_pending: 'to be clarified (table 23)',
          drawing: '{h} h (drawing)',
          default: '{h} h',
          none: 'none registered'
        }
      },
      weldingHold: {
        flag: 'Welding hold',
        wps: 'Welding hold on WPS {wps}',
        welder: 'Welding hold for the welder',
        since: 'since {date}',
        notBlocking: 'Warning – the weld can be registered, the office has been notified.'
      },
      pendingSync: 'Waiting for sync',
      noSymbol: 'Symbol missing',
      noExecution: 'No execution registered yet',
      close: 'Close',
      noDrawingFile: 'No drawing uploaded for this drawing',
      noPreview: 'Preview not available for this file type',
      imageFailed: 'Drawing image could not be loaded',
      roles: {
        fitter: 'Sheet metal worker',
        welder: 'Welder',
        vt: 'VT control'
      },
      hints: {
        fitter: '{n} joints waiting for assembly — tap a blue dashed marker',
        fitterDone: 'All assemblies done!',
        welder: '{n} ready to weld — tap a pulsing marker',
        welderNone: 'No joints ready — waiting for assembly',
        welderNdt: 'All welds done — {n} waiting for NDT testing',
        welderDone: 'All welds done and checked!',
        vt: '{n} joints waiting for VT control — tap a gold marker',
        vtDone: 'Nothing waiting for VT — all checked!',
        vtNdtOpen: '{n} VT-approved — waiting for the other NDT methods (signed on the web)',
        loading: 'Loading welds…'
      },
      materials: 'Material traceability',
      heat: 'Heat/charge',
      heatMissing: 'Heat missing',
      bulkFitUp: 'Fitted',
      bulkWeldEnd: 'Welded',
      bulkWeldList: 'Signs these welds',
      changeHistory: 'Change history',
      auditField: {
        fillerBatch: 'Weld batch',
        batchPf: 'Assembly batch',
        filler: 'Filler',
        certificateRefs: 'Weld certificate',
        assemblyPf: 'Assembly certificate',
        vtLevel: 'VT level',
        // WIT-FIX-CERT-5348-001 F2: the certificate decision in Endringslogg.
        certVerdict: 'Certificate check',
        certOverrideReason: 'Override reason',
        certUnqualifiedSign: 'Signed without a qualifying certificate',
        traceabilityGaps: 'Signed with missing traceability',
        certRegisteredLater: 'Certificate registered afterwards'
      },
      auditFrom: 'From',
      auditTo: 'To',
      auditNoChange: 'Saved without changes',
      auditAction: {
        add: 'Added',
        flag: 'Flagged',
        update: 'Changed',
        delete: 'Removed'
      },
      posLabel: 'Pos',
      posNrMissing: 'Pos nr. missing',
      noMaterials: 'No materials in the plan',
      addMaterial: 'Add',
      fillAllMaterials: 'Fill in all',
      fillAllHint: 'Material type, heat, thickness and pos for every material on this weld. Only changed rows are saved.',
      newMaterial: 'New material',
      editMaterial: 'Edit material',
      materialHint: 'Scan the mark on the steel, or enter it manually.',
      scanQr: 'Scan the label (QR)',
      scanNfc: 'RFID/NFC',
      scanComingNext: 'Scanning is added in a later step — enter manually below',
      orManual: 'OR WRITE MANUALLY',
      materialType: 'Material type',
      selectType: 'Select material type',
      editFieldHint: 'Only the fields you change are saved. Signature, date and VT are left untouched.',
      noTypeMatches: 'No matches',
      noTypesInRegister: 'No material types in the register',
      heatNo: 'Heat / charge no.',
      heatTypeNew: 'Other… (type new heat no.)',
      heatFromMaterialList: 'From the material list',
      thickness: 'Thickness (mm)',
      posNo: 'Item no. (bar/column table)',
      saveChanges: 'Save changes',
      gapWarnTitle: 'Missing details',
      gapWarnHint: 'This joint is missing details in the material traceability. Sign anyway?',
      gapWarnYes: 'Yes, sign anyway',
      gapWarnNo: 'No, fill in now',
      gapThickness: 'thickness missing',
      gapType: 'material type missing',
      gapRow: 'Row {n}',
      bulkSignVt: 'VT approve all {n}',
      bulkConfirm: 'Confirm',
      bulkTitleVt: 'VT approve all ready welds',
      bulkHint: 'Approves the {n} welds waiting for VT on this drawing. Any missing details are listed afterwards.',
      bulkSigned: '{n} signed',
      bulkSkipped: '{n} skipped',
      bulkGapsTitle: 'Traceability gaps',
      bulkGapsHint: 'These welds are missing details. You can approve anyway, or cancel and complete them first.',
      gapHeat: 'heat missing',
      gapPosNr: 'pos nr missing',
      gapNoMaterials: 'no materials',
      cancel: 'Cancel',
      removeMaterial: 'Remove material',
      removeMaterialConfirm: 'Remove material {n}? It is deleted from this weld at once.',
      saving: 'Saving…',
      repairNote: 'VT rejected this — rework and register again. The new weld is linked to the original (revision tracking).',
      actFitUp: 'Compilation completed',
      actWeld: 'Weld complete',
      actRepair: 'Repaired and welded',
      actVtOk: 'VT approved — level {level}',
      actVtReject: 'Reject — send to repair',
      actionsComingNext: 'Registration is wired up in the next step',
      vtSignedNdtOpen: 'VT approved — other NDT outstanding',
      noAction: 'No {role} action on this joint now ({status})'
    },
    advancedWeldLog: {
      // 5183 / R-2.7c: the production-series column in the weld list.
      spoolNo: 'Spool / part no.',
      // 5183 / R-2.7d: route to the weld-mapping screen, where the flow lives.
      addFieldWeld: 'Add weld in the field',
      noDrawingsFound: 'No drawings found',
      folderLIst: 'Folder List',
      projectDrawings: 'Project Drawings',
      drawingNumber: 'Drawing Number',
      weldCount: 'Weld Count',
      engineering: 'Engineering',
      production: 'Production',
      ndt: 'NDT',
      pending: 'Pending',
      inProgress: 'In Progress',
      completed: 'Completed',
      ndtFaultScope: 'NDT Fault Scope',
      submit: 'Submit',
      cancel: 'Cancel',
      newWeldLog: 'Weld Log',
      updateWeldLog: 'Weld Log',
      weldNo: 'Weld no',
      jointType: 'Joint type',
      wps: 'WPS',
      weldingConsumables: 'Welding Consumables',
      batchNumber: 'Heat / Batch nr',
      welderCertificates: 'Welder Certificates',
      weldEnd: 'Weld End',
      ok: 'Ok',
      sign: 'Sign',
      comments: 'Comments',
      notAcceptable: 'Not Acceptable',
      fault: 'Fault',
      noResultsFound: 'No results found.',
      drawing: 'Drawing',
      projectName: 'Project Name',
      aoRanked: 'AO Ranked',
      poRanked: 'PO Ranked',
      searchWeldLogs: 'Search weld logs',
      confirmWeldLogDelete: 'Are you sure you want to remove weld {weld_nr}',
      weldingProcess: 'Welding process',
      ndts: 'NDTs',
      searchDrawings: 'Search Drawings',
      selectDrawing: 'Select a drawing',
      noWeldLogResultsFound: 'No weldlog results found!',
      selectDrawingToLoadWeldLogs: 'Select a drawing to load weldlogs!',
      certificateRequiredWhenWeldEnd: 'Certificate is required when Weld End is selected.'
    }
  }
}
